import React, { useState } from "react";
import { StickyNavbar } from "../layout/StickyNavBar";
import { SpinnerWithInfo } from "../layout/SpinnerWithInfo";
import { AlertCustomStyles } from "../layout/AlertCustomStyles";
import RegisterStepOne from "./RegisterStepOne";
import RegisterStepTwo from "./RegisterStepTwo";
import { Link, useNavigate } from "react-router-dom";
import UserService from "../../services/user.service";
import { getCustomerConstants, emailTypes } from "../../utils/constants";
import { Dialog, Card } from "@material-tailwind/react";
import AuthTransferShowcase from "../layout/AuthTransferShowcase";
const Register = () => {
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const [alert, setAlert] = useState("");
  const [firstStepData, setIsFirstStepData] = useState({});
  const [redirecting, setRedirecting] = useState(false);
  const [sentCode, setSentCode] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const handleNext = async (data) => {
    setMsg("Please wait...");
    setLoading(true);
    setIsFirstStepData(data);
    setAlert("");
    const verify = await UserService.sendVerificationCode({
      email: data.email,
      emailType: emailTypes.VERIFY,
    });
    if (verify.code) {
      setSentCode(verify.code);
      setActiveStep((cur) => cur + 1);
      setLoading(false);
    } else {
      setLoading(false);
      setAlert("fail");
    }
  };
  const handlePrev = () => {
    setActiveStep((cur) => cur - 1);
    setAlert("");
  };
  const register = () => {
    const userObj = {
      firstName: firstStepData.firstName,
      lastName: firstStepData.lastName,
      phone: firstStepData.phoneNumber,
      email: firstStepData.email,
      password: firstStepData.password,
      country: getCustomerConstants.COUNTRY,
      dateOfBirth:
        firstStepData.month +
        " " +
        firstStepData.day +
        ", " +
        firstStepData.year,
      localCurrency: getCustomerConstants.LOCAL_CURRENCY,
      role: getCustomerConstants.ROLE,
      status: 1,
    };
    UserService.addUser(userObj)
      .then(async (res) => {
        setMsg("Registered! Redirecting to login...");
        setTimeout(() => {
          setLoading(false);
          navigate("/login");
        }, 5000);
      })
      .catch((err) => {
        setAlert("fail");
        setIsFirstStepData({});
        setLoading(false);
      });
  };
  const onVerifyComplete = () => {
    setLoading(true);
    register();
  };
  return (
    <div className="auth-page min-h-screen bg-[#f7f3ed] text-[#302521]">
      {!redirecting && (
        <div className="sticky top-0 z-50">
          <StickyNavbar pageType="register" />
        </div>
      )}
      <main className="flex min-h-[calc(100dvh-72px)] items-center justify-center px-4 py-2 sm:px-6 sm:py-6">
        <div className="auth-frame grid w-full max-w-[760px] grid-cols-1 overflow-hidden rounded-[22px] border border-[#e6ddd2] bg-[#fffdf9] shadow-[0_24px_64px_rgba(66,48,34,0.12)] lg:grid-cols-2">
          <section className="auth-form-panel flex flex-col justify-center px-5 py-3 sm:px-7 sm:py-6 lg:px-8">
            {alert && (
              <AlertCustomStyles
                status={alert}
                message={
                  alert == "success"
                    ? "Registration was successful"
                    : "Something went wrong, Please try again"
                }
              />
            )}
            {activeStep == 0 && !redirecting && (
              <div>
                <RegisterStepOne
                  onStepOneComplete={(data) => handleNext(data)}
                  firstStepData={firstStepData}
                />
                <p className="mt-5 text-center text-xs text-[#766b64]">
                  Already have an account?
                  <Link to="/login" className="ml-1 font-semibold text-[#882699] underline underline-offset-2">
                    Log in
                  </Link>
                </p>
              </div>
            )}
            {activeStep == 1 && !redirecting && (
              <div>
                <RegisterStepTwo
                  onVerifyComplete={onVerifyComplete}
                  email={firstStepData.email}
                  originalSentCode={sentCode}
                  /*  handlePrev={handlePrev}
                  showPrev={true} */
                />
              </div>
            )}
          </section>
          <AuthTransferShowcase />
        </div>
        {/* {redirecting && (
          <div className="">
            <SpinnerWithInfo message="Registration was successful, redirecting you to login..." />
          </div>
        )} */}
        {loading && (
          <Dialog
            size="sm"
            open={true}
            className="bg-transparent shadow-none opacity-60"
            dismiss={{
              escapeKey: false,
              referencePress: false,
              outsidePress: false,
              ancestorScroll: false,
              bubbles: false,
            }}
          >
            <Card className="mx-auto w-full max-w-[26rem] p-4">
              <SpinnerWithInfo message={msg} />
            </Card>
          </Dialog>
        )}
      </main>
    </div>
  );
};
export default Register;
